export enum PointsType {
    EXPERIENCE = "Experience",
    COINS = "Coins"
}